const a = {
  Unknown: "Other",
  "Russian Federation": "Russia",
  "Republic of Lithuania": "Lithuania",
  "Iran, Islamic Republic of": "Iran",
  "Republic of Moldova": "Moldova",
  "Moldova, Republic of": "Moldova",
  "Korea, Republic of": "Republic of Korea",
  "Republic of the Congo": "Congo",
  "DR Congo": "Democratic Republic of the Congo",
  "Congo, The Democratic Republic of the": "Democratic Republic of the Congo"
};
function t(n) {
  return Object.keys(n).reduce((o, i) => {
    const e = n[i];
    return o[e] ? o[e].push(i) : o[e] = [e, i], o;
  }, {});
}
const u = t(a);
export {
  a as COUNTRY_ALIASES,
  u as COUNTRY_NAME_TO_VALUE_LOOKUP,
  t as aggregateCountryNamesToArray
};
